module.exports = __webpack_public_path__ + "static/media/tirlan.a21c8f14.jpg";